import { supabase } from "@/integrations/supabase/client";

export interface ChitPayment {
  id: string;
  chit_pool_id: string;
  member_id: string;
  month_number: number;
  payment_date: string;
  amount_paid: number;
  created_at: string;
  updated_at: string;
}

export const getPaymentsForChitPool = async (chitPoolId: string): Promise<ChitPayment[]> => {
  const { data, error } = await supabase
    .from('chit_payments')
    .select('*')
    .eq('chit_pool_id', chitPoolId)
    .order('month_number', { ascending: true });

  if (error) throw error;
  return data || [];
};

export const getPaymentsForMember = async (memberId: string): Promise<ChitPayment[]> => {
  const { data, error } = await supabase
    .from('chit_payments')
    .select('*')
    .eq('member_id', memberId)
    .order('month_number', { ascending: true });

  if (error) throw error;
  return data || [];
};

export const recordPayment = async (
  chitPoolId: string,
  memberId: string,
  monthNumber: number,
  amountPaid: number,
  paymentDate: Date
): Promise<ChitPayment> => {
  const { data, error } = await supabase
    .from('chit_payments')
    .upsert({
      chit_pool_id: chitPoolId,
      member_id: memberId,
      month_number: monthNumber,
      amount_paid: amountPaid,
      payment_date: paymentDate.toISOString()
    }, {
      onConflict: 'member_id,month_number'
    })
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const deletePayment = async (paymentId: string): Promise<void> => {
  const { error } = await supabase
    .from('chit_payments')
    .delete()
    .eq('id', paymentId);

  if (error) throw error;
};